export const freshGraduate = {
  id: 'fresh-graduate',
  version: 2,
  renderer: 'enterprise',
  name: 'Fresh Graduate Starter',
  layout: 'single-column',
  theme: 'classic-navy',
  persona: ['student'],
  atsLevel: 'A',
  scoreWeights: {
    ats: 45,
    visual: 15,
    executive: 10,
    student: 30
  },
  sectionOrder: ['personal-info', 'summary', 'education', 'projects', 'skills', 'languages'],
  components: {
    header: 'header-centered',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-section'
  },
  metadata: {
    industry: ['Tech Giants', 'Professional Services', 'Finance Corporates'],
    companies: ['Dell', 'Deloitte', 'EY', 'PwC', 'KPMG', 'HP', 'Cognizant'],
    ats: ['Workday', 'Taleo', 'Lever', 'Greenhouse'],
    pages: { min: 1, max: 1, preferred: 1 },
    photo: false,
    icons: false,
    density: 'high',
    columns: 1,
    experienceLevel: ['Student', 'Entry-level'],
    careerStage: 'Fresh Graduate',
    recommendedFor: ['College Graduates', 'Entry Level Analysts', 'Technical Trainees'],
    avoidFor: ['Tenured Executives', 'Creative Professionals', 'Academic CVs'],
    dna: ['Starter-Clean', 'ATS-Perfect', 'Structured', 'Navy-Classic', 'Sans-Serif'],
    metrics: {
      readingDifficulty: 97,
      scanningSpeed: 96,
      visualAppeal: 81
    },
    hiringManager: {
      firstImpression: "Polished, serious fresh graduate with a clean layout and structured background",
      scanningStyle: "Top-to-bottom scan focusing on degree type, GPAs, skill list, and main project achievements",
      preferredStructure: "Summary, education, projects, skills, languages",
      dislikes: ["Over-designed layouts", "Spelling or formatting mistakes", "Unmeasurable details"]
    },
    strategy: {
      goal: "Pass standard corporate screeners and present credentials cleanly on a single page",
      focus: "Degree name, coding certifications, and core technology proficiencies",
      avoid: ["Gimmicky visual bars", "Icons", "Over-segmentation"]
    },
    psychology: {
      coreTraits: ["Trustworthiness", "Structure", "Academic compliance", "Reliability"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Focus on student projects, lab experiments, coding certifications, and skills matches. Use standard corporate language.",
      rewriteStyle: "Structured, clean, professional"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9pt",
      lineHeight: 1.35,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'education', 'projects', 'skills', 'languages']
      },
      overrides: {
        '--font-family-primary': '"Inter", sans-serif',
        '--spacing-margin': '24px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '24pt',
    '--weight-display': '700',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--heading-weight': '700',
    '--border-thickness-heading': '1.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '20px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px',
    '--color-text-main': '#2C3E50',
    '--color-text-light': '#7F8C8D'
  }
};
export default freshGraduate;
